import { Button, Modal, Box } from "@mui/material";

interface Props {
  modalOpen: boolean;
  setModalOpen: (value: boolean) => any;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 374,
  height: 163,
  borderWidth: 0,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderColor: "background.paper",
  borderRadius: "24px",
  paddingTop: "32px",
  paddingBottom: "34px"
};

function CustomModal({ modalOpen, setModalOpen }: Props) {
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex flex-col justify-around h-full">
            <div className="mx-auto mb-8">
              <p className="font-montserrat text-black text-sm font-medium">
                Please fill all the mandatory details.
              </p>
            </div>
            <div className="flex justify-center">
              <Button
                className="cursor-pointer !uppercase h-13 w-37.5 rounded-lg"
                variant="contained"
                onClick={() => handleCloseModal()}
              >
                OK
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default CustomModal;
